import { NotistackService } from "./services/NotistackService";

export const notistackService = new NotistackService();
